namespace Matrix.Data {
    export interface DataParameter {
        Name?: string;
        Title?: string;
        Type?: DataType;
        Required?: boolean;
        Size?: number;
        Scale?: number;
        DefaultValue?: string;
        EditorType?: string;
        EditorParams?: { [key: string]: any };
    }
}
